module.exports = __webpack_public_path__ + "static/media/usd.4847d5be.svg";